import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../../tables/tableDevices/tableDevices/medium/style/style.css';
import { PREVIEW_URL, VIDEO_PREVIEW_URL } from '../../../const/const';
import IconOnline from '../../icons/iconOnline/IconOnline';
import IconOffline from '../../icons/iconOffline/IconOffline';
import { useSelectedDevice } from '../../../store/devices/SelectedDevice';
import { Device } from '../../../types/Device';
import img from './Video.png';
import { useAuthStore } from '../../../store/auth/auth';

interface CardComponentProps {
    device: Device;
    handleViewVideo: (uid: string) => void;
}

const CardComponent: React.FC<CardComponentProps> = ({ device, handleViewVideo }) => {
    const navigate = useNavigate();
    const { setSelectedDevice } = useSelectedDevice();
    const [mediaUrl, setMediaUrl] = useState<string>('');
    const { SmartDVRToken, user } = useAuthStore.getState();
    const handleDeviceClick = (deviceUID: string) => {
        navigate(`/device/${deviceUID}`);
        setSelectedDevice(device);
    };

    const handleError = (e: any) => {
        e.target.src = img; // Устанавливаем локальную картинку при ошибке загрузки
    };

    useEffect(() => {
        const loadMedia = async () => {
            try {
                if (!device?.UID || !SmartDVRToken) return;

                const response = await fetch(PREVIEW_URL(device.UID), {
                    headers: {
                        SmartDVRLogin: user?.login || '',
                        SmartDVRToken: SmartDVRToken,
                    },
                });

                if (!response.ok) throw new Error('Failed to fetch media');

                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                setMediaUrl(url);
            } catch (error) {
                console.error('Error fetching media:', error);
                setMediaUrl(img);
            }
        };

        loadMedia();

        return () => {
            if (mediaUrl && mediaUrl !== img) {
                URL.revokeObjectURL(mediaUrl);
            }
        };
    }, [device?.UID, SmartDVRToken, user?.login]);

    return (
        <div
            className="containerCard"
            onClick={() => handleDeviceClick(device.UID)}
            style={{ borderRadius: 0 }}
        >
            <Card
                className="coverCard"
                key={device.ID}
                cover={
                    <img
                        alt=""
                        className="img"
                        src={mediaUrl || img}
                        style={{ width: 340, height: 192, borderRadius: 0 }}
                    />
                }
                onError={handleError}
                style={{ borderRadius: 0 }}
            />
            <div className="propertiesPart1">
                <h1 className="name">
                    <div className="icon">{device.online ? <IconOnline /> : <IconOffline />}</div>
                    {device.name}
                </h1>
                <div className="propertyGroup">
                    <h3 className="property">Группа: {device.groupName}</h3>
                    <h3 className="property">Модель: {device.model}</h3>
                    <h3 className="property">Номер: {device.DID}</h3>
                    <h3 className="property">Сотрудник: {device.ownerName}</h3>
                </div>
            </div>
        </div>
    );
};

export default CardComponent;
